import type { OrganisationInvitationSentResponseAccessResponseStatusEnum } from '@api-client/api'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { StatusPillContainer } from './styles'

interface Props {
	status: OrganisationInvitationSentResponseAccessResponseStatusEnum
}

const InvitationStatusPill: React.FC<Props> = ({ status }) => {
	const { t } = useTranslation()

	const statusToLabel = useMemo(
		() => ({
			ACCEPTED: t('complete'),
			DECLINED: t('declined'),
			PENDING: t('open'),
		}),
		[t]
	)

	return <StatusPillContainer>{statusToLabel[status]}</StatusPillContainer>
}

export { InvitationStatusPill }
